import Vue from 'vue'
import VueI18n from 'vue-i18n'
import common from './common/js/common.js'

Vue.use(VueI18n)

function loadLocaleMessages() {
  const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const messages = {}
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      messages[locale] = locales(key)
    }
  })
  return messages
}

const messages = loadLocaleMessages()

Vue.prototype.$languages = Object.keys(messages).map(langlage => ({
  label: messages[langlage]._name,
  value: langlage
}))

let lang = common.getCookie('lang') || navigator.language || navigator.browserLanguage
lang = lang.toLowerCase()
if (lang.indexOf('tw') !== -1 || lang.indexOf('hk') !== -1) {
  lang = 'tw'
} else if (lang.indexOf('en') !== -1) {
  lang = 'en'
} else if (lang.indexOf('id') !== -1) {
  lang = 'id'
} else if (lang.indexOf('th') !== -1) {
  lang = 'th'
} else if (lang.indexOf('es') !== -1) {
  lang = 'es'
} else if (lang.indexOf('ar') !== -1) {
  lang = 'ar'
  document.documentElement.setAttribute('dir', 'rtl')
} else {
  lang = 'zh'
}

export default new VueI18n({
  locale: lang,
  fallbackLocale: 'zh',
  messages
})



// WEBPACK FOOTER //
// ./src/i18n.js